var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1241 17.8708L35.9583 17.0366C37.3404 15.6545 39.5813 15.6545 40.9634 17.0366C42.3455 18.4187 42.3455 20.6596 40.9634 22.0417L40.1292 22.8759L32.4601 30.5451C31.9406 31.0645 31.6809 31.3242 31.3945 31.5476C31.0567 31.8111 30.6912 32.037 30.3045 32.2213C29.9766 32.3775 29.6282 32.4937 28.9313 32.726L26.7 33.4697L25.9781 33.7104L25.2563 33.951C24.9133 34.0653 24.5352 33.9761 24.2796 33.7204C24.0239 33.4648 23.9347 33.0867 24.049 32.7437L24.2896 32.0219L24.5303 31.3L25.274 29.0687C25.5063 28.3718 25.6225 28.0234 25.7787 27.6955C25.963 27.3088 26.1889 26.9433 26.4524 26.6055C26.6758 26.3191 26.9355 26.0594 27.4549 25.5399L35.1241 17.8708Z",
    fill: "#B7CCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3601 16.0787L37.2869 15.1518C38.8226 13.6161 41.3125 13.6161 42.8482 15.1518C44.3839 16.6875 44.3839 19.1774 42.8482 20.7131L41.9213 21.6399M36.3601 16.0787C36.3601 16.0787 36.4759 18.0483 38.2138 19.7862C39.9517 21.5241 41.9213 21.6399 41.9213 21.6399M36.3601 16.0787L27.8388 24.5999C27.2617 25.1771 26.9731 25.4656 26.7249 25.7838C26.4321 26.1592 26.1811 26.5653 25.9763 26.995C25.8027 27.3593 25.6737 27.7465 25.4156 28.5208L24.5892 31L24.3218 31.8021M41.9213 21.6399L33.4001 30.1612C32.8229 30.7383 32.5344 31.0269 32.2162 31.2751C31.8408 31.5679 31.4347 31.8189 31.005 32.0237C30.6407 32.1973 30.2535 32.3263 29.4792 32.5844L27 33.4108L26.1979 33.6782M26.1979 33.6782L25.3958 33.9456C25.0148 34.0726 24.5947 33.9734 24.3106 33.6894C24.0266 33.4053 23.9274 32.9852 24.0544 32.6042L24.3218 31.8021M26.1979 33.6782L24.3218 31.8021",
    stroke: "#081E54",
    strokeWidth: 1.37143
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26H21",
    stroke: "#A020FF",
    strokeWidth: 1.37143,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18H29",
    stroke: "#A020FF",
    strokeWidth: 2.05714,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 34H19",
    stroke: "#A020FF",
    strokeWidth: 1.02857,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6569 6.34315C37.3137 4 33.5425 4 26 4H22C14.4575 4 10.6863 4 8.34315 6.34315C6 8.68629 6 12.4575 6 20V28C6 35.5425 6 39.3137 8.34315 41.6569C10.6863 44 14.4575 44 22 44H26C33.5425 44 37.3137 44 39.6569 41.6569C41.543 39.7707 41.9109 36.9591 41.9826 32",
    stroke: "#081E54",
    strokeWidth: 1.02857,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteIcon);
export default __webpack_public_path__ + "static/media/WriteIcon.4f39aea1bbfb3e46da7573741011c6aa.svg";
export { ForwardRef as ReactComponent };